import React from 'react';
import { BrandLogo } from './BrandLogo';
import { useLanguage } from '../contexts/LanguageContext';
export function PrivacyPolicy() {
  const {
    setLang
  } = useLanguage();
  return <div className="min-h-screen w-full bg-white" data-id="element-376" data-mp="24z1o0u75u2sf">
      <header className="border-b border-ink/10 bg-white px-6 py-4" data-id="element-377" data-mp="24yrxn5i7dtm7">
        <a href="/" className="flex items-center gap-3 font-display text-lg font-extrabold uppercase tracking-[0.18em] text-ink" data-id="element-378" data-mp="1zzyuo70jll0a">
          <BrandLogo tone="light" className="h-10 w-10" data-id="element-379" data-mp="1cb5qxodoi8v4" />
          MIAMI CAR QUEENS
        </a>
      </header>
      
      <main className="mx-auto max-w-3xl px-6 py-16 text-body" data-id="element-380" data-mp="186y45wqs72zj">
        <h1 className="font-display text-3xl font-extrabold uppercase text-ink" data-id="element-381" data-mp="1m17iwr95kbfb">Privacy Policy</h1>
        <p className="mt-2 text-sm text-muted" data-id="element-382" data-mp="1h8xk0lq2810w">Last Updated: August 2026</p>

        <div className="mt-10 space-y-8 text-sm leading-relaxed" data-id="element-383" data-mp="tjmuk0e5tt22">
          <section data-id="element-384" data-mp="ths6id7ldktr">
            <h2 className="font-display text-lg font-bold uppercase text-ink" data-id="element-385" data-mp="olbkppnv7iju">1. Information We Collect</h2>
            <p className="mt-3" data-id="element-386" data-mp="30wr6als0ot46">
              We collect information that you provide directly to us when you fill out a form, request an estimate, or communicate with us via WhatsApp, SMS, or email. This may include your name, phone number, email address, vehicle interest, and basic credit situation.
            </p>
          </section>

          <section data-id="element-387" data-mp="3fklze39xszhs">
            <h2 className="font-display text-lg font-bold uppercase text-ink" data-id="element-388" data-mp="3fmyiijrflfwf">2. How We Use Your Information</h2>
            <p className="mt-3" data-id="element-389" data-mp="2mwgijrm07un8">
              We use the information we collect to:
            </p>
            <ul className="mt-2 list-inside list-disc space-y-1 pl-2" data-id="element-390" data-mp="2rvkqkex6zmbz">
              <li data-id="element-391" data-mp="2rxnpjogbopsu">Provide, maintain, and improve our services.</li>
              <li data-id="element-392" data-mp="2vy7p0yodc5i5">Communicate with you about your vehicle inquiry.</li>
              <li data-id="element-393" data-mp="75vbq1who0ja">Send you promotional messages and updates (only if you have opted in).</li>
              <li data-id="element-394" data-mp="b6nnb1su2hiq">Connect you with dealership financing and sales options.</li>
            </ul>
          </section>

          <section data-id="element-395" data-mp="286s574dyjjb8">
            <h2 className="font-display text-lg font-bold uppercase text-ink" data-id="element-396" data-mp="2868lbi4qykuk">3. SMS and Communications (TCPA)</h2>
            <p className="mt-3" data-id="element-397" data-mp="237yt9gebk0d6">
              By submitting your phone number, you authorize MIAMI CAR QUEENS LLC to text/call the number provided for promotional messages, possibly using automated means. Message and data rates may apply. Message frequency varies. Consent is not a condition of purchase. You can reply STOP at any time to unsubscribe or HELP for help.
            </p>
          </section>

          <section data-id="element-398" data-mp="1kjtpwa1kqhew">
            <h2 className="font-display text-lg font-bold uppercase text-ink" data-id="element-399" data-mp="1kg5x5d3ydz18">4. Sharing of Information</h2>
            <p className="mt-3" data-id="element-400" data-mp="1tinkxvz9azqc">
              We do not sell your personal information. We share your information only with our affiliated dealership (Doral Kia) and necessary service providers (like our CRM, GoHighLevel) strictly for the purpose of fulfilling your vehicle request and managing our communications with you.
            </p>
          </section>

          <section data-id="element-401" data-mp="3cfs5kmvjqn1c">
            <h2 className="font-display text-lg font-bold uppercase text-ink" data-id="element-402" data-mp="3cfih53q5gnxr">5. Contact Us</h2>
            <p className="mt-3" data-id="element-403" data-mp="3ha68rbgg9ygk">
              If you have any questions about this Privacy Policy, please contact us via WhatsApp using the buttons provided on our website.
            </p>
          </section>
        </div>

        <div className="mt-16" data-id="element-404" data-mp="7t7pwu058w">
          <a href="/" className="inline-block border-b-2 border-gold pb-1 font-display text-sm font-bold uppercase tracking-widest text-ink transition-colors hover:text-kred" data-id="element-405" data-mp="zsbapn0l3x">
            ← Back to Home
          </a>
        </div>
      </main>
    </div>;
}